.body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 28px;
}

// One clean header row: segmented control (left) + actions (right).
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

// Segmented control — track + selected pill (replaces the old underline tabs).
.segmented {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  background: var(--color-secondary, #f3f4f6);
  border-radius: 9px;
}

.segment {
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-muted, #6b7280);
  border-radius: 7px;
  transition:
    color 0.15s,
    background-color 0.15s,
    box-shadow 0.15s;

  &:hover {
    color: var(--color-foreground, #111827);
  }
}

.segment-active {
  background: var(--color-background, #fff);
  color: var(--color-foreground, #111827);
  box-shadow: 0 1px 2px rgb(0 0 0 / 10%);
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 8px;
}

.ref-link {
  color: var(--color-primary, #2563eb);
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.item-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
